import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getCurrentUser } from 'aws-amplify/auth';
import { useAuthStore } from '../../../store/authStore';
import Loader from '../../../components/Common/Loader';

const SsoCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  const { login } = useAuthStore();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const errorParam = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        if (errorParam) {
          throw new Error(errorDescription || `OAuth error: ${errorParam}`);
        }

        const user = await getCurrentUser();

        if (user) {
          // Use AuthStore login method without credentials (SSO already authenticated)
          await login();
          navigate('/');
        } else {
          throw new Error('Failed to authenticate user');
        }
      } catch (err) {
        console.error('SSO Callback Error:', err);
        const errorMessage = err instanceof Error ? err.message : 'Authentication failed';
        setError(errorMessage);

        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    };

    handleCallback();
  }, [navigate, login]);

  if (isLoading) {
    return (
      <div className="container txt-contenido">
        <Helmet>
          <title>DISGENET: SSO Login</title>
          <meta name="description" content="Completing SSO login." />
        </Helmet>
        <div className="login-container mb-5">
          <div className="signin-container">
            <div className="col-12 text-center">
              <Loader text="Completing SSO login..." />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container txt-contenido">
        <Helmet>
          <title>DISGENET: SSO Login Error</title>
          <meta name="description" content="SSO login error." />
        </Helmet>
        <div className="login-container mb-5">
          <div className="signin-container">
            <div className="col-12 text-center">
              <h3 className="login-title" style={{ color: 'white' }}>
                SSO Login Error
              </h3>
              <p style={{ color: 'white', marginBottom: '20px' }}>{error}</p>
              <p style={{ color: 'white' }}>Redirecting to login page...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SsoCallback;
